import { TrainingCourse } from '../../types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiTrainingCourse = (strapiData: any): TrainingCourse => {
    const { id, name, code, trainerName } = strapiData

    return {
        id,
        name,
        code,
        trainerName,
    }
}

export {
    fromStrapiTrainingCourse,
}